import React, { useMemo } from "react";
import upload from "../../../Assets/newUpload.svg";
import style from "./index.module.css";
import plus from "../../../Assets/newPlus.svg";
import { Box, Button, Flex, Heading, Img, Input, Text } from "@chakra-ui/react";
import roboto from "@fontsource/roboto";
import { useNavigate } from "react-router-dom";
import epilouge from "@fontsource/epilogue";
import company from "../../../Assets/Company_Icon.png";
import { isDisabled } from "@testing-library/user-event/dist/utils";

const First = ({ changeFile, formData, changeHandler, setPage }) => {
  const navigate = useNavigate();

  const preview = useMemo(() => {
    return formData.logo && typeof formData.logo !== "string"
      ? URL.createObjectURL(formData.logo)
      : null;
  }, [formData.logo]);
  // console.log("prev", preview);

  return (
    <div className={style.maincont}>
      {/* Heading */}
      <Box>
        <Heading
          style={{ fontFamily: "Epilogue" }}
          fontSize={40}
          fontWeight={700}
        >
          Setup Company
        </Heading>
        <Text fontFamily={roboto} fontSize={16} fontWeight={400}>
          Add company name and logo
        </Text>
      </Box>
      {/* profile pic */}
      <div className={style.uploadphoto}>
        {preview === null ? (
          <img
            style={{ height: "100px", width: "100px", marginTop: "-1rem" }}
            src={plus}
            alt=""
          />
        ) : (
          <img src={preview} alt="" />
        )}
      </div>
      <label
        htmlFor="file"
        style={{
          fontFamily: "Roboto",
          fontSize: "18px",
          letterSpacing: "0.04em",
          fontWeight: "500",
        }}
        className={style.uploadBtn}
      >
        <img src={upload} alt="" />
        <input
          id="file"
          type="file"
          placeholder="Profile Photo"
          name="logo"
          onChange={changeFile}
          hidden
          autoComplete="off"
        />
        Upload
      </label>

      <Flex
        border="1px solid #DCDCDC"
        m={"auto"}
        mt={14}
        mb={4}
        px={6}
        py={2}
        borderRadius={12}
      >
        <Flex align={"center"} gap={2}>
          <img style={{ height: "16px" }} src={company} alt="Icon" />
          <Input
            placeholder="Company name"
            variant="unstyled"
            name="companyName"
            fontSize={16}
            fontFamily="Roboto"
            letterSpacing={"0.04em"}
            value={formData.companyName}
            onChange={changeHandler}
            autoComplete="off"
          />
        </Flex>
      </Flex>
      <div className={style.btnGroup}>
        <button
          className={style.backBtn}
          onClick={() => {
            navigate(-1);
          }}
        >
          Back
        </button>
        {!formData.companyName || !formData.logo ? (
          <button
            disabled
            style={{ cursor: "not-allowed" }}
            className={style.nextBtn}
          >
            Next
          </button>
        ) : (
          <button className={style.nextBtn} onClick={() => setPage(1)}>
            Next
          </button>
        )}
      </div>
      <Flex
        display={"none"}
        bg={"#6C56FB"}
        align="center"
        justify="center"
        // py={[1, 1, 2, 2, 2]}
        gap={2}
        borderRadius={12}
        mt={4}
        _hover={{ bg: "#8E48FF" }}
        cursor={
          !formData.companyName || !formData.logo ? "not-allowed" : "pointer"
        }
        onClick={() => setPage(1)}
      >
        {/* Next Button */}
        <button
          style={{
            cursor:
              !formData.companyName || !formData.logo
                ? "not-allowed"
                : "pointer",
            color: "#ffffff",
            fontSize: "18px",
            fontFamily: "Roboto",
            fontWeight: "500",
            letterSpacing: "0.04em",
            padding: "0.5rem 3rem",
          }}
        >
          Next
        </button>
      </Flex>
    </div>
  );
};

export default First;
